import React from 'react';

import { Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';

interface PreviousLogCircuitMiniTableProps {
  title: string;
  data: any[];
  circuitCount?: number;
}

const PreviousLogCircuitMiniTable: React.FC<PreviousLogCircuitMiniTableProps> = (props) => {
  let { data, title, circuitCount } = props;

  const getCircuitCount = () => {
    if (circuitCount) return circuitCount;
    if (!data || data.length === 0) return 0;

    const firstRow = data[0];
    const circuitKeys = Object.keys(firstRow).filter((key) => key.startsWith('circuit') && key.endsWith('Value'));
    return circuitKeys.length;
  };

  const actualCircuitCount = getCircuitCount();

  return (
    <Table size="small">
      <TableHead>
        <TableRow style={{ background: '#A21C37' }}>
          <TableCell style={{ width: '250px', color: '#fff', fontWeight: 700 }}>{title}</TableCell>
          {Array.from({ length: actualCircuitCount }, (_, i) => (
            <TableCell key={i} style={{ color: '#fff', fontWeight: 700 }}>
              Circuit {i + 1}
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>
        {data?.map((item, index) => (
          <TableRow key={index}>
            <TableCell>{item?.display_name}</TableCell>
            {Array.from({ length: actualCircuitCount }, (_, i) => (
              <TableCell key={i}>{item?.[`circuit${i + 1}Value`]}</TableCell>
            ))}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

export default PreviousLogCircuitMiniTable;
